import React from "react";

import { useState, useEffect } from "react";
// import "./styles.css";
function Tile({ imageSrc, applink, keyno, applength })  {

  return (
    <div className='tile'>
            <a target='_blank' href={applink}>
              <img className='applogo' src={imageSrc} alt="App Logo" />
            </a>
    </div>
  );
}

export default Tile;